function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import './InlineError.scss';
import cs from 'classnames';
import I18n from '../../I18n/I18n/I18n';
import ClientColorCss from '../../ClientColorCss/ClientColorCss';
import shade from '../../utils/colors/shade';
export default function InlineError(_ref) {
  var theme = _ref.theme,
    _ref$metaType = _ref.metaType,
    metaType = _ref$metaType === void 0 ? '' : _ref$metaType,
    type = _ref.type,
    id = _ref.id,
    i18n = _ref.i18n,
    size = _ref.size;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ClientColorCss, {
    id: "inline-error-text"
  }, function (_ref2) {
    var trimColorSecondary = _ref2.trimColorSecondary;
    return "._dm-inline-error--dm { color: ".concat(shade(trimColorSecondary, 15), "; }");
  }), /*#__PURE__*/React.createElement("span", {
    id: id,
    className: cs("_dm-inline-error _dm-inline-error--".concat(size), "_dm-inline-error--".concat(type, " _dm-inline-error--").concat(type, "--").concat(size), "_dm-inline-error--".concat(theme, " _dm-inline-error--").concat(theme, "--").concat(size), _defineProperty(_defineProperty({}, "_dm-inline-error--".concat(metaType), metaType), "_dm-inline-error--".concat(metaType, "--").concat(size), metaType), 'auto-error'),
    "aria-live": i18n ? 'assertive' : 'off',
    "aria-relevant": "text"
  }, i18n && /*#__PURE__*/React.createElement(I18n, {
    i18n: i18n
  })));
}